
export default (that) => [
  {
    field: 'seq',
    width: 60,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    headerAlign: 'center',
    align: 'center',
    fixed: 'right',
    width: 90,
    slots: { default: 'opt' },
  },
  {
    title: that.$l('table_label_workLogTime') || '报工日期	',
    field: 'reportDate',
    minWidth: 120,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_status') || '状态',
    field: 'status',
    minWidth: 100,
    align: 'center',
    slots: { default: 'status' },
    showHeaderOverflow: true,
  },
  // {
  //   title: '员工工号',
  //   field: 'userNo',
  //   minWidth: 120,
  //   headerAlign: 'center',
  //   align: 'center',
  //   showHeaderOverflow: true,
  //   showOverflow: true,
  // },
  {
    title: that.$l('table_label_userName') ||'员工姓名',
    field: 'userName',
    minWidth: 120,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'userName' },
  },
  {
    title: that.$l('table_label_workShiftName') || '班次',
    field: 'workShiftName',
    minWidth: 80,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_processName') || '工序',
    field: 'nodeName',
    minWidth: 180,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_techName') || '工艺名称',
    field: 'processName',
    minWidth: 180,
    align: 'center',
    showHeaderOverflow: true,
  },
  // {
  //   title: that.$l('table_label_techChargeUnit') || '数量单位',
  //   field: 'techChargeUnitText',
  //   minWidth: 120,
  //   align: 'center',
  //   showHeaderOverflow: true,
  //   showOverflow: true,
  // },
  {
    title: that.$l('table_label_checkedQty') || '批次数量',
    field: 'checkedQty',
    minWidth: 120,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_passQty') || '良品数量',
    field: 'passQty',
    minWidth: 120,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_notPassQty') || '不良品数量',
    field: 'notPassQty',
    minWidth: 120,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_yieldRate') || '良品率',
    field: 'yieldRate',
    minWidth: 120,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
    slots: { default: 'yieldRate' },
  },
  {
    title: that.$l('table_label_reworkTime') || '返修时间',
    field: 'reworkTime',
    minWidth: 120,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_recheckTime') || '复检时间',
    field: 'recheckTime',
    minWidth: 120,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_recheckPassQty') || '复检通过数量',
    field: 'recheckPassQty',
    minWidth: 120,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_recheckFailedQty') || '复检报废数量',
    field: 'recheckFailedQty',
    minWidth: 120,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_masterNcNo') || '成品编码',
    field: 'masterNcNo',
    minWidth: 200,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_ncNo') || '子件编码',
    field: 'ncNo',
    minWidth: 200,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_goodsName') || '产品名称',
    field: 'goodsName',
    minWidth: 200,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_categoryFullName') || '产品分类',
    field: 'categoryFullName',
    minWidth: 200,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_factoryOrderNo') || '工厂订单编号',
    field: 'factoryOrderNo',
    minWidth: 200,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },

  {
    title: that.$l('table_label_custName') || '客户',
    field: 'custName',
    minWidth: 180,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_custOrderNo') || '客户订单编号',
    field: 'custOrderNo',
    minWidth: 180,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_displayCreate') || '创建人',
    field: 'displayCreate',
    width: 170,
    align: 'center',
    showHeaderOverflow: true,
    slots: { default: 'displayCreate' },
  },
  {
    title: that.$l('table_label_displayModify') || '修改人',
    field: 'displayModify',
    width: 170,
    align: 'center',
    showHeaderOverflow: true,
    slots: { default: 'displayModify' },
  }
]
